export const BRAND = {
  name: "Beyond Borders Travel",
  short: "Beyond Borders",
  tagline: "Seamless Corporate Travel, Beyond Expectations",
  address: "Shop No 23, Gravity Mall City Center, Lilongwe, Malawi",
  phones: ["+265 986 26 11 30", "+265 990 50 12 52"],
  email: "info@beyondbordertravels.com",
  whatsappNumber: "265986261130",
  whatsappUrl: "https://wa.me/265986261130",
  logoUrl:
    "https://customer-assets.emergentagent.com/job_cbc66b44-0514-45ee-99b9-5cf768b56ee5/artifacts/zc6mfblo_Gemini_Generated_Image_kctegukctegukcte%20%283%29.png",
  social: {
    instagram: "https://instagram.com",
    facebook: "https://facebook.com",
    linkedin: "https://linkedin.com",
    twitter: "https://twitter.com",
  },
};

// Currently operating branches. Lilongwe entry mirrors the primary BRAND
// contact exactly — do not modify without also updating BRAND.
export const BRANCHES = [
  {
    id: "lilongwe",
    city: "Lilongwe",
    country: "Malawi",
    flag: "🇲🇼",
    address: "Shop No 23, Gravity Mall City Center, Lilongwe, Malawi",
    phones: ["+265 986 26 11 30", "+265 990 50 12 52"],
    emails: ["info@beyondbordertravels.com"],
    whatsappNumber: "265986261130",
    hours: "Mon–Sat · 08:00 – 18:00 CAT",
    supportNote: "24/7 support for active travellers",
    mapEmbedSrc:
      "https://www.google.com/maps?q=Gravity%20Mall%20City%20Center%20Lilongwe%20Malawi&output=embed",
    mapTitle: "Beyond Borders Travel — Gravity Mall, Lilongwe",
  },
  {
    id: "malabo",
    city: "Malabo",
    country: "Equatorial Guinea",
    flag: "🇬🇶",
    address:
      "Calle Presidente NASSER, No° 80, near GETESA office, Malabo, Equatorial Guinea",
    phones: ["+240 555 600 842", "+240 555 549 879"],
    emails: [
      "reservation.malabo@beyondbordertravels.com",
      "beyondbordersmalabo@gmail.com",
    ],
    whatsappNumber: "240555600842",
    hours: "Mon–Sat · 08:00 – 18:00 WAT",
    supportNote: "24/7 support for active travellers",
    mapEmbedSrc:
      "https://www.google.com/maps?q=Calle%20Presidente%20Nasser%2080%20Malabo%20Equatorial%20Guinea&output=embed",
    mapTitle: "Beyond Borders Travel — Calle Presidente Nasser, Malabo",
  },
];

// Future expansion locations. Intentionally without addresses, phones or
// emails — these are planned branches, not currently operating offices.
export const UPCOMING_BRANCHES = [
  { id: "zambia", country: "Zambia", flag: "🇿🇲" },
  { id: "dubai", country: "Dubai, UAE", flag: "🇦🇪" },
  { id: "mozambique", country: "Mozambique", flag: "🇲🇿" },
  { id: "tanzania", country: "Tanzania", flag: "🇹🇿" },
];

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Services", to: "/services" },
  { label: "Destinations", to: "/destinations" },
  { label: "Corporate Solutions", to: "/corporate-solutions" },
  { label: "About", to: "/about" },
  { label: "Contact", to: "/contact" },
];

export const SERVICES = [
  {
    id: "flights",
    icon: "Plane",
    title: "Flight Bookings",
    short: "International & Domestic",
    description:
      "Curated flight inventory with priority access to business and first-class fares across 800+ airlines worldwide.",
  },
  {
    id: "visa",
    icon: "BookCheck",
    title: "Visa Assistance",
    short: "Effortless documentation",
    description:
      "End-to-end visa processing for tourist, business and transit visas — paperwork handled, approvals tracked.",
  },
  {
    id: "hotels",
    icon: "Building2",
    title: "Hotel Reservations",
    short: "Five-star to boutique",
    description:
      "Negotiated corporate rates at luxury chains and signature boutique stays — complimentary upgrades when available.",
  },
  {
    id: "cars",
    icon: "Car",
    title: "Car Rentals",
    short: "Chauffeur or self-drive",
    description:
      "Premium fleet partnerships across continents. Airport-to-meeting transfers, multi-city itineraries, instant confirmations.",
  },
  {
    id: "insurance",
    icon: "ShieldCheck",
    title: "Travel Insurance",
    short: "Worry-free journeys",
    description:
      "Comprehensive policies covering medical, trip cancellation, baggage and corporate liability — tailored to your risk profile.",
  },
  {
    id: "corporate",
    icon: "Briefcase",
    title: "Corporate Travel Management",
    short: "Enterprise-grade",
    description:
      "Dedicated account manager, policy compliance, real-time spend visibility and 24/7 traveller support.",
  },
  {
    id: "cruises",
    icon: "Ship",
    title: "Cruise Packages",
    short: "Ocean & river cruises",
    description:
      "Hand-selected itineraries with the world's leading cruise lines — staterooms, suites and exclusive shore experiences.",
  },
  {
    id: "holidays",
    icon: "Palmtree",
    title: "Holiday Packages",
    short: "Curated escapes",
    description:
      "Bespoke leisure journeys — honeymoons, family safaris, milestone celebrations across our most-loved destinations.",
  },
];

export const WHY_US = [
  {
    icon: "Headphones",
    title: "24/7 Dedicated Support",
    body: "Real humans on the line at 03:00 — whenever the journey changes, we're already on it.",
  },
  {
    icon: "BadgeCheck",
    title: "Best Price Guarantee",
    body: "Negotiated corporate fares and rate parity audits ensure you never overpay.",
  },
  {
    icon: "Briefcase",
    title: "Corporate Travel Expertise",
    body: "A decade of advising executives, delegations and global mobility teams.",
  },
  {
    icon: "Zap",
    title: "Fast & Hassle-Free Booking",
    body: "Confirmations within minutes. Approvals, invoices and itineraries — all in one thread.",
  },
  {
    icon: "Globe2",
    title: "Global Partnerships",
    body: "IATA accredited with relationships across 800+ airlines and 1M+ properties.",
  },
  {
    icon: "Sparkles",
    title: "Personalized Solutions",
    body: "Travel policies, traveller profiles and preferences shaped around your business.",
  },
];

export const CORPORATE_SOLUTIONS = [
  {
    icon: "FileText",
    title: "Travel Policy Management",
    body: "Codify, distribute and enforce your travel policy with intelligent guardrails and approval flows.",
  },
  {
    icon: "TrendingDown",
    title: "Expense Optimization",
    body: "Spend analytics, supplier negotiation and category-level savings with monthly board-ready reports.",
  },
  {
    icon: "UserCheck",
    title: "Dedicated Account Manager",
    body: "A named senior consultant who knows your team, your travellers and your priorities by heart.",
  },
  {
    icon: "BarChart3",
    title: "Reporting & Analytics",
    body: "Live dashboards covering bookings, CO₂, traveller wellbeing and policy compliance.",
  },
  {
    icon: "Users",
    title: "Group & Event Travel",
    body: "Conferences, incentives, off-sites — logistics, accommodation and transfers handled end-to-end.",
  },
];

export const DESTINATIONS = [
  {
    id: "dubai",
    name: "Dubai",
    region: "United Arab Emirates",
    image:
      "https://images.pexels.com/photos/31084537/pexels-photo-31084537.jpeg",
    blurb: "Skyline summits, desert luxury and the Gulf's premier business hub.",
  },
  {
    id: "thailand",
    name: "Thailand",
    region: "Southeast Asia",
    image:
      "https://images.unsplash.com/photo-1528181304800-259b08848526?w=1600&q=80",
    blurb: "Bangkok boardrooms by day, island retreats by sunset.",
  },
  {
    id: "europe",
    name: "Europe",
    region: "Paris · Rome · London",
    image: "https://images.pexels.com/photos/587838/pexels-photo-587838.jpeg",
    blurb: "Heritage capitals, modern hubs and seamless rail networks.",
  },
  {
    id: "south-africa",
    name: "South Africa",
    region: "Cape Town · Johannesburg",
    image:
      "https://images.pexels.com/photos/35348775/pexels-photo-35348775.jpeg",
    blurb: "Two oceans, world-class wine country and conferencing par excellence.",
  },
  {
    id: "maldives",
    name: "Maldives",
    region: "Indian Ocean",
    image:
      "https://images.unsplash.com/photo-1758717152007-6a2eb7299409?w=1600&q=80",
    blurb: "Overwater villas and signature retreats for executive recharge.",
  },
  {
    id: "santorini",
    name: "Santorini",
    region: "Greece",
    image:
      "https://images.unsplash.com/photo-1604503245604-930a6f3513ef?w=1600&q=80",
    blurb: "Caldera views, white-washed boutique stays and Aegean privacy.",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "Beyond Borders made our corporate travel effortless and cost-effective. Their team became an extension of ours.",
    author: "Tariro M.",
    role: "Head of Operations, Pan-African Logistics Group",
  },
  {
    quote:
      "Professional, fast, and highly reliable service. Last-minute reroute to Johannesburg confirmed in eleven minutes.",
    author: "Daniel K.",
    role: "Managing Director, Lilongwe Capital Partners",
  },
  {
    quote:
      "The most quietly luxurious travel programme we've ever had. Our executives notice every detail.",
    author: "Aisha B.",
    role: "Chief of Staff, Sahara Energy Holdings",
  },
];

export const STATS = [
  { value: "10+", label: "Years of expertise" },
  { value: "180", label: "Countries served" },
  { value: "98%", label: "Client retention" },
  { value: "24/7", label: "Traveller support" },
];

export const buildWhatsAppLink = (message, whatsappNumber) => {
  const encoded = encodeURIComponent(message || "Hello Beyond Borders Travel — I'd like a quote.");
  const num = whatsappNumber || BRAND.whatsappNumber;
  return `https://wa.me/${num}?text=${encoded}`;
};

// Standard prefilled quote message opener — used by every "Get a Quote" CTA
export const QUOTE_WA = buildWhatsAppLink(
  "Hello Beyond Borders Travel,\n\nI'd like to request a quote for my upcoming trip.\n\nPlease get back to me at your earliest convenience."
);

// mailto: deep-link builder — opens user's mail client with subject + body prefilled
export const buildEmailLink = (subject, body, to) => {
  const params = new URLSearchParams({
    subject: subject || "Enquiry — Beyond Borders Travel",
    body: body || "Hello Beyond Borders Travel,\n\nI'd like to request a quote.\n\nThank you.",
  });
  return `mailto:${to || BRAND.email}?${params.toString().replace(/\+/g, "%20")}`;
};
